const getDrawerHeight = (characterCount) => {
  if (characterCount < 120) {
    return 50;
  }
  if (characterCount >= 120 && characterCount < 200) {
    return 60;
  }
  if (characterCount >= 200 && characterCount <= 400) {
    return 75;
  }
  return 90;
};

export default getDrawerHeight;
